export default __webpack_public_path__ + "static/quality_image1-8dfdd05e753551e943d81d31dcd13349.png";